// подвал (footer) тут начинаеться ге***ой

import React, { useState, useRef, useEffect } from "react";
import styled, { css } from "styled-components";
import { useTheme } from "../context/ThemeContext";

// --- EmailJS IT-шники ---
const SERVICE_ID = "service_3fxt3ob";
const TEMPLATE_ID = "template_svb4v2n";
/* тут еще был PUBLIC_KEY но я его отправил на index.html 
из-за непонятных мне конфликтов */

const contactLinks = [
  {
    name: "Telegram",
    light: "./icons/telegram.png",
    dark: "./icons/telegram-d.png",
    href: "https://t.me/k417e",
  },
  {
    name: "Email",
    light: "./icons/mail.png",
    dark: "./icons/mail-d.png",
    href: "mailto:geldijanow@gmail.com",
  },
  {
    name: "GitHub",
    light: "./icons/github.png",
    dark: "./icons/github-d.png",
    href: "https://github.com/ezizovb",
  },
];

const MaxWidthWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 30px 20px 15px;
  @media (max-width: 500px) {
    padding: 20px 20px 15px;
  }
`;

const FooterWrapper = styled.footer`
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #1f2937;
  font-family: Arial, sans-serif;
  padding-top: 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);

  body.dark-theme & {
    background-color: #1a1a1a;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    color: var(--color-text);
    box-shadow: 0 -2px 10px rgba(255, 255, 255, 0.05);
  }
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  font-family: Philosopher;
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  color: var(--color-text);
`;

// --- Аааккардионы ти-ра-ра-ра-рам ---
const AccordionContainer = styled.div`
  margin-top: 30px;
  border-radius: 15px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;

  body.dark-theme & {
    background-color: #2a2a2a;
    border: 1px solid #374151;
    box-shadow: 0 4px 10px rgba(255, 255, 255, 0.05);
  }
`;

const AccordionItem = styled.div`
  border-bottom: 1px solid #e5e7eb;
  body.dark-theme & {
    border-bottom: 1px solid #374151;
  }
  &:last-child {
    border-bottom: none;
  }
`;

const AccordionHeader = styled.button`
  width: 100%;
  padding: 20px;
  background: transparent;
  color: inherit;
  border: none;
  text-align: left;
  font-size: 1.4rem;
  font-family: Philosopher;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;

  &:focus,
  &:focus-visible {
    outline: none;
  }

  &:hover {
    background-color: #f5f5f5;
  }
  body.dark-theme &:hover {
    background-color: #37415155;
  }
`;

const ToggleIcon = styled.span`
  font-size: 1.5rem;
  color: var(--color-accent-green, #059669);
  transform: rotate(0deg);
  transition: transform 0.3s ease;
  ${(props) =>
    props.$open &&
    css`
      transform: rotate(45deg);
    `}
`;

const AccordionContent = styled.div`
  max-height: 0;
  overflow: hidden;
  transform-origin: top;
  transform: scaleY(0);
  opacity: 0;
  transition: max-height 0.4s ease-out,
    transform 0.45s cubic-bezier(0.68, -0.6, 0.32, 1.6), opacity 0.4s ease-out;
  background-color: #ffffff;
  border-radius: 50px;

  body.dark-theme & {
    background-color: #2a2a2a;
  }

  ${(props) =>
    props.$open &&
    css`
      max-height: 600px;
      transform: scaleY(1);
      opacity: 1;
      transition: max-height 0.5s ease-in,
        transform 0.5s cubic-bezier(0.68, -0.6, 0.32, 1.6), opacity 0.5s ease-in;
    `}
`;

const ContentPadding = styled.div`
  padding: 20px;
  line-height: 1.6;
  color: var(--color-text);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const BaseInputStyles = css`
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #fcfcfc;
  color: #1f2937;
  font-size: 1rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);

  &:focus,
  &:focus-visible {
    outline: none;
    border-color: var(--color-accent-green, #059669);
    background-color: #fff;
    box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.2);
  }

  body.dark-theme & {
    background-color: #374151;
    border-color: #4b5563;
    color: white;
    box-shadow: inset 0 1px 3px rgba(255, 255, 255, 0.05);
  }

  body.dark-theme &:focus {
    background-color: #2a2a2a;
    box-shadow: 0 0 0 2px rgba(56, 200, 56, 0.3);
  }
`;

const Input = styled.input`
  ${BaseInputStyles}
`;

const TextArea = styled.textarea`
  ${BaseInputStyles}
  min-height: 120px;
  resize: vertical;
`;

const SubmitButton = styled.button`
  padding: 12px 25px;
  background-color: var(--color-accent-button-bg, #9d9ea534);
  color: var(--color-text);
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-accent-green, rgba(5, 150, 105, 0.4));
  }

  &:hover {
    ${(props) =>
      !props.disabled &&
      css`
        background-color: #777a9681;
        transform: translateY(-2px);
      `}
  }

  body.dark-theme &:hover {
    ${(props) =>
      !props.disabled &&
      css`
        background-color: #55586b81;
        transform: translateY(-2px);
      `}
  }
`;

const StatusMessage = styled.div`
  padding: 10px;
  border-radius: 4px;
  font-weight: 500;
  text-align: center;
  margin-top: 10px;

  ${(props) =>
    props.$type === "success" &&
    css`
      background-color: #d1fae5;
      color: #065f46;
    `}

  ${(props) =>
    props.$type === "error" &&
    css`
      background-color: #fee2e2;
      color: #991b1b;
    `}
`;

/* - Компонент FeedbackForm  (я тут слишком много времени провел чем планированный( - */
const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setStatus(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus(null);

    if (!window.emailjs || !window.emailjs.send) {
      console.error(
        "EmailJS SDK не загружен. Проверьте CDN и emailjs.init() в index.html"
      );
      setStatus("error");
      setIsSubmitting(false);
      return;
    }

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email, // сохраняем шаблон EmailJS
      message: formData.message,
    };

    try {
      await window.emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams);
      setStatus("success");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("EmailJS не смог отправить сообщение:", error);
      setStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ContentPadding>
      <p style={{ marginBottom: "15px" }}>
        Буду рад вашим вопросам, предложениям и запросам о сотрудничестве.
      </p>
      <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="name"
          placeholder="Имя"
          value={formData.name}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <Input
          type="email"
          name="email"
          placeholder="Ваш Email"
          value={formData.email}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <TextArea
          name="message"
          placeholder="Ваше Сообщение..."
          value={formData.message}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />

        {status === "success" && (
          <StatusMessage $type="success">
            Сообщение успешно отправлено! Спасибо.
          </StatusMessage>
        )}
        {status === "error" && (
          <StatusMessage $type="error">
            Ошибка отправки. Проверьте ключи EmailJS и настройки SDK.
          </StatusMessage>
        )}

        <SubmitButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Отправка..." : "Отправить"}
        </SubmitButton>
      </Form>
    </ContentPadding>
  );
};

// --- Контакты ---
const IconGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  padding: 10px 0;
  @media (max-width: 640px) {
    padding: 0;
  }
`;

const IconLink = styled.a`
  color: var(--color-text);
  font-size: 2.5rem;
  transition: color 0.3s ease, transform 0.3s ease;

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-accent-green, rgba(5, 150, 105, 0.4));
    border-radius: 50%;
  }

  &:hover {
    color: var(--color-accent-green, #059669);
    transform: translateY(-3px);
  }
`;

const IconsContact = styled.img`
  width: 50px;
  height: 50px;
  filter: none !important;
  @media (max-width: 640px) {
    width: 35px;
    height: 35px;
  }
`;

const About = styled.div`
  text-align: center;
  padding-top: 40px;
  font-size: 0.8rem;
  color: var(--color-text);
  font-family: "Monserat";
  @media (max-width: 640px) {
    font-size: 0.65rem;
  }
  body.dark-theme & a {
    color: #46acffff;
  }
`;
// тут старый дизайн иконки только для одной темы(лайт)

// const ContactIcons = () => (
//   <ContentPadding>
//     <p style={{ textAlign: "center", marginBottom: "20px" }}>
//       Мои контакты и профили:
//     </p>
//     <IconGrid>
//       <IconLink href="https://t.me/k417e" target="_blank" title="Telegram">
//         <IconsContact src="./icons/telegram.png" />
//       </IconLink>

//       <IconLink href="mailto:geldijanow@gmail.com" title="Email">
//         <IconsContact src="./icons/mail.png" />
//       </IconLink>

//       <IconLink
//         href="https://github.com/ezizovb"
//         target="_blank"
//         title="GitHub"
//       >
//         <IconsContact src="./icons/github.png" />
//       </IconLink>
//     </IconGrid>
//   </ContentPadding>
// );

const ContactIcons = () => {
  // получаем состояние темы
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <ContentPadding>
      <p style={{ textAlign: "center", marginBottom: "20px" }}>
        Мои контакты и профили:
      </p>
      <IconGrid>
        {/* исползуем массив и map */}
        {contactLinks.map((item) => {
          // dynamic way
          const iconSrc = isDark ? item.dark : item.light;
          return (
            <IconLink
              key={item.name}
              href={item.href}
              title={item.name}
              // условие для target = "_blank": только если это не эмайл
              {...(item.name === "Email"
                ? {}
                : { target: "_blank", rel: "noopener noreferrer" })}
            >
              <IconsContact src={iconSrc} alt={`${item.name} icon`} />
            </IconLink>
          );
        })}
      </IconGrid>
    </ContentPadding>
  );
};

// --- Accordion данные ---
const accordionData = [
  { id: "feedback", title: "Написать мне", content: <FeedbackForm /> },
  { id: "contacts", title: "Контакты", content: <ContactIcons /> },
];

// --- Footer ---
export default function Footer() {
  const [openSection, setOpenSection] = useState(null);
  const itemRefs = useRef({});

  useEffect(() => {
    if (openSection) {
      const element = itemRefs.current[openSection];
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 1);
      }
    }
  }, [openSection]);

  const toggleSection = (id) => {
    setOpenSection((current) => (current === id ? null : id));
  };

  return (
    <FooterWrapper id="contacts">
      <MaxWidthWrapper>
        <SectionTitle>Связаться со мной</SectionTitle>

        <AccordionContainer>
          {accordionData.map((item) => {
            const isOpen = openSection === item.id;
            return (
              <AccordionItem key={item.id}>
                <AccordionHeader
                  onClick={() => toggleSection(item.id)}
                  ref={(el) => (itemRefs.current[item.id] = el)}
                >
                  {item.title}
                  <ToggleIcon $open={isOpen}>+</ToggleIcon>
                </AccordionHeader>
                <AccordionContent $open={isOpen}>
                  {item.content}
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </AccordionContainer>

        <About>
          <p>&copy; {new Date().getFullYear()} K41. All rights reserved. </p>
          <a
            style={{ color: "green", marginRight: "10px" }}
            href="https://github.com/ezizovb/k41darkside"
          >
            &lt;Исходный код проекта&gt;
          </a>
          <a
            href="https://ezizovb.github.io/k41/cv.pdf"
            download="Ezizmyrat_Geldijanow_CV.pdf"
            class="download-link"
          >
            скачать cv (pdf)
          </a>
        </About>
      </MaxWidthWrapper>
    </FooterWrapper>
  );
}
